import React, { useState } from 'react';
import { galleryCategories } from '../utils/galleryData';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Keyboard } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

const GallerySection = () => {
  const [activeGallery, setActiveGallery] = useState(null);

  return (
    <section className="py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4">

        {/* Heading */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-slate-900 mb-4">
            Our Cleaning Gallery
          </h2>
          <p className="text-slate-600">
            Explore our work by service category
          </p>
        </div>

        {/* Folder Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6">
          {galleryCategories.map((item) => (
            <button
              key={item.id}
              onClick={() => setActiveGallery(item)}
              className="group text-center focus:outline-none"
            >
              <div className="relative rounded-xl overflow-hidden shadow-md">
                <img
                  src={item.cover}
                  alt={item.title}
                  loading="lazy"
                  className="h-32 w-full object-cover
                             group-hover:scale-110
                             transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black/20" />
              </div>

              <p className="mt-2 text-sm font-medium text-slate-800">
                {item.title}
              </p>
            </button>
          ))}
        </div>

        {/* Modal Gallery */}
        {activeGallery && (
          <div
            className="fixed inset-0 z-50 bg-black/70
                       flex items-center justify-center px-4"
          >
            <div className="relative bg-white w-full max-w-5xl rounded-lg p-4">

              {/* Close Button */}
              <button
                onClick={() => setActiveGallery(null)}
                className="absolute top-3 right-3
                           text-slate-600 hover:text-black
                           text-xl font-bold"
                aria-label="Close gallery"
              >
                ✕
              </button>

              {/* Title */}
              <h3 className="text-xl font-bold text-center mb-4">
                {activeGallery.title}
              </h3>

              {/* Swiper */}
              <Swiper
                modules={[Navigation, Keyboard]}
                navigation
                keyboard={{ enabled: true }}
                loop
                observer
                observeParents
                className="rounded-lg"
              >
                {activeGallery.images.map((img, idx) => (
                  <SwiperSlide key={idx}>
                    <div
                      className="flex items-center justify-center
                                 h-[50vh] md:h-[60vh] lg:h-[70vh]
                                 bg-black rounded-lg"
                    >
                      <img
                        src={img}
                        alt={`${activeGallery.title} ${idx + 1}`}
                        loading="lazy"
                        className="max-h-full max-w-full
                                   object-contain"
                      />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>

            </div>
          </div>
        )}

      </div>
    </section>
  );
};

export default GallerySection;
